import { RootState } from "@/redux/store";

export const accountsSelector = (state: RootState) => state.account.accounts;
export const activeAccountSelector = (state: RootState) => state.account.activeAccount;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const accountIdSelector = (state: any) => state.account.activeAccount.id;
